import FormInput from './PrepFormInput';

/**
 * Form for entering the number of remaining cases and units from the original, unprepped lot.
 *
 * @param {object} props
 * @param {number} props.remainingCases - The number of remaining cases.
 * @param {number} props.remainingUnits - The number of remaining units.
 * @param {number} props.unitsPerCase - The number of units per case.
 * @param {function} props.onDataChange - Function to handle data changes.
 * @returns {JSX.Element}
 */
function Step2_RemainingItemsForm({ remainingCases, remainingUnits, unitsPerCase, onDataChange }) {
    return (
        <div className="grid grid-cols-2 gap-x-8 gap-y-3">
            <FormInput
                label="Remaining Cases"
                name="remainingCases"
                type="number"
                required
                value={remainingCases || ''}
                onChange={onDataChange}
                tooltip={`Enter the number of full cases remaining from the original, unprepped lot. Each case contains ${unitsPerCase} units.`}
            />
            <FormInput
                label="Remaining Units"
                name="remainingUnits"
                type="number"
                required
                value={remainingUnits || ''}
                onChange={onDataChange}
                tooltip="Enter the number of loose units remaining from the original, unprepped lot."
            />
        </div>
    );
}

export default Step2_RemainingItemsForm;
